import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { User } from '../../services/types';
import UserCard from './UserCard';

interface UsersListViewProps {
    users: User[];
    allowedLogins: Set<string>;
    onEdit: (user: User) => void;
    onDelete: (id: string) => void;
    onAllowLoginChange: (user: User, isChecked: boolean) => void;
}

const UsersListView: React.FC<UsersListViewProps> = ({
    users,
    allowedLogins,
    onEdit,
    onDelete,
    onAllowLoginChange,
}) => {
    return (
        <Row className="g-4">
            {users.map((user, index) => (
                <Col key={user.public_id} xs={12} sm={6} md={4} lg={3}>
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3, delay: index * 0.05 }}
                    >
                        <UserCard
                            user={user}
                            isAllowedLogin={allowedLogins.has(user.public_id)}
                            onEdit={onEdit}
                            onDelete={onDelete}
                            onAllowLoginChange={onAllowLoginChange}
                        />
                    </motion.div>
                </Col>
            ))}
        </Row>
    );
};

export default UsersListView;